import ServicePageTemplate from "../components/ServicePageTemplate";
import usePageMeta from "../hooks/usePageMeta";
import { STUBBFRASNING_FAQS } from "../data/faqs";

export default function Stubbfrasning() {
  usePageMeta({
    title: "Stubbfräsning efter trädfällning | Trädfällarna Laholm AB",
    description:
      "Stubbfräsning i Laholm med omnejd — smidig borttagning av stubbar inför ny gräsmatta, plantering eller anläggning.",
  });

  return (
    <ServicePageTemplate
      eyebrow="Tjänst"
      title="Stubbfräsning efter trädfällning"
      intro="Efter att ett träd har fällts kan stubben stå i vägen för gräsmatta, plantering, byggnation eller annan användning av marken. Vi fräser bort stubben effektivt så att ytan kan användas igen."
      heroImage="/images/hero-stubbfrasning.webp"
      heroImagePosition="55% 55%"
      bodyHeading="Marken redo att användas igen"
      bodyText="Med stubbfräs tar vi bort stubben några decimeter under markytan så att du kan så gräs, plantera nytt, lägga sten eller bygga ovanpå. Vi arbetar skonsamt mot omgivande mark och rotsystem."
      bullets={[
        "Smidig borttagning av stubbar i alla storlekar",
        "Skonsamt mot omgivande mark och växtlighet",
        "Bra inför ny gräsmatta, plantering eller anläggning",
        "Kan kombineras med trädfällning och bortforsling",
        "Spån kan lämnas på plats eller fraktas bort",
      ]}
      faqId="stubbfrasning-faq"
      faqTitle="Vanliga frågor om stubbfräsning"
      faqItems={STUBBFRASNING_FAQS}
    />
  );
}
